import { RefObject } from "react"

import { webClientConfig } from "@shared/apis"
import { getParam } from "@shared/modules"
import {
  getSignedAt,
  getVodWmsAuthToken,
  getWmsAuthToken,
} from "@shared/modules"
import { accountService } from "@shared/services"

import dayjs, { OpUnitType } from "dayjs"

const LIVE_EXPIRE_HOUR = 9
const VOD_EXPIRE_MINUTE = 54

export default {
  getStreamingUrl: async (
    streamingUrl: string,
    type: PlayerType,
    isAnonymous?: boolean,
  ): Promise<string> => {
    let expireTime: number = LIVE_EXPIRE_HOUR,
      unitType: OpUnitType = "hour"

    if (type === "VOD") {
      expireTime = VOD_EXPIRE_MINUTE
      unitType = "minute"
    }

    if (getSignedAt() && isExpire(expireTime, unitType)) {
      type === "VOD" && isAnonymous
        ? await accountService.check(
            webClientConfig.scheduleId,
            getParam("ticket", ""),
            getParam("username"),
            getParam("partner_id"),
            true,
          )
        : await accountService.refreshToken()
    }

    const wmsAuthToken =
      type === "VOD" ? getVodWmsAuthToken() : getWmsAuthToken()

    if (wmsAuthToken) {
      return `${streamingUrl}?wmsAuthSign=${wmsAuthToken}`
    }

    return streamingUrl
  },
  handleFullMode: (videoWrapRef: RefObject<HTMLDivElement>): void => {
    const videoWrap = videoWrapRef!.current! as any
    const doc = document as any
    if (doc.fullscreenElement || doc.msFullscreenElement) {
      if (doc.exitFullscreen) {
        doc.exitFullscreen()
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen()
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen()
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen()
      }
    } else {
      if (videoWrap.requestFullscreen) {
        videoWrap.requestFullscreen()
      } else if (videoWrap.mozRequestFullScreen) {
        videoWrap.mozRequestFullScreen()
      } else if (videoWrap.webkitRequestFullScreen) {
        videoWrap.webkitRequestFullScreen()
      } else if (videoWrap.msRequestFullscreen) {
        videoWrap.msRequestFullscreen()
      }
    }
  },
}

function isExpire(expireTime: number, unitType: OpUnitType): boolean {
  return dayjs().isAfter(dayjs(Number(getSignedAt())).add(expireTime, unitType))
}

export type PlayerType = "LIVE" | "VOD"
